export const GET_ALL_PESQUISAS_SATISFACAO = 'GET_ALL_PESQUISAS_SATISFACAO'
export const GET_PESQUISA_SATISFACAO_ESPECIFICA = 'GET_PESQUISA_SATISFACAO_ESPECIFICA'
export const GET_PESQUISA_USE = 'GET_PESQUISA_USE'
export const GET_ALL_AUDIOS = 'GET_ALL_AUDIOS'
